import { Link } from 'react-router-dom';
import { specials } from '@/mocks/specials';

export default function Special() {
  return (
    <div className="mx-auto w-full px-4 py-8 md:px-6">
      <nav className="mb-4 flex items-center gap-2 text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600">首页</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-foreground-800">专题合集</span>
      </nav>

      <div className="mb-8 rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">专题合集</h1>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
          我们按主题为你精心编排影视片单：星际漫游、古装悬疑、治愈深夜档、都市情感……每一次点开，都是一场不重样的观影之旅。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {specials.map((special) => (
          <Link
            key={special.id}
            to={`/special/${special.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="relative h-44 w-full overflow-hidden bg-background-200">
              <img
                src={special.cover}
                alt={`${special.title} 专题封面`}
                title={`${special.title} 专题推荐`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-3 left-4 right-4">
                <h2 className="text-lg font-bold text-white group-hover:text-primary-200">{special.title}</h2>
                <p className="text-xs text-white/80">{special.subtitle}</p>
              </div>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{special.description}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">
                  {special.mediaIds.length} 部精选
                </span>
                <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                  查看片单 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}